export type Tenant = 'tripura' | 'dps' | null;

export function getTenantFromHostname(hostname: string = window.location.hostname): Tenant {
  if (hostname === 'localhost') return null;

  const parts = hostname.split('.');

  if (parts.length === 2 && parts[0] === 'aitutor' && parts[1] === 'local') return null;

  if (parts.length === 3 && parts[0] === 'aitutor' && parts[2] === 'local') {
    const tenant = parts[1]?.toLowerCase();
    if (tenant === 'tripura' || tenant === 'dps') return tenant;
  }

  return null;
}
